import { useState } from 'react'
import { Button, Input } from '@/components/ui'
import { trpc } from '@/lib/trpc'
import { useAppStore } from '@/stores/app.store'

export function AccountTab() {
  const addToast = useAppStore((s) => s.addToast)
  const me = trpc.auth.me.useQuery()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const changePassword = trpc.auth.changePassword.useMutation({
    onSuccess: () => {
      addToast({ type: 'success', title: 'Passwort geändert' })
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
    },
    onError: (e) => addToast({ type: 'error', title: 'Fehler', description: e.message }),
  })

  const mismatch = newPassword.length > 0 && confirmPassword.length > 0 && newPassword !== confirmPassword
  const canSubmit = currentPassword && newPassword.length >= 6 && newPassword === confirmPassword

  return (
    <div className="p-6 max-w-sm space-y-6">
      <div>
        <h3 className="text-sm font-semibold text-text-primary mb-1">Angemeldet als</h3>
        <p className="text-sm text-text-secondary">{me.data?.user.name ?? me.data?.user.email ?? '—'}</p>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-text-primary">Passwort ändern</h3>
        <Input
          label="Aktuelles Passwort"
          type="password"
          autoComplete="current-password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <Input
          label="Neues Passwort"
          type="password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <Input
          label="Neues Passwort bestätigen"
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {mismatch && <p className="text-xs text-danger">Die Passwörter stimmen nicht überein.</p>}
        <Button
          variant="primary"
          disabled={!canSubmit}
          loading={changePassword.isPending}
          onClick={() =>
            changePassword.mutate({ currentPassword, newPassword })
          }
        >
          Passwort ändern
        </Button>
      </div>
    </div>
  )
}
